import {SET_SLIDE_LOADING, SET_SLIDE_NOT_LOADING} from "../redux_constants/slideLoading.constant";


const InitialState = {
    loading: false,
    slideId: null
}

export const slideLoadingReducer = (state = InitialState, action) => {
    switch (action.type) {
        case SET_SLIDE_LOADING:
            return {
                loading: true,
                slideId: action.slideId
            }
        case SET_SLIDE_NOT_LOADING:
            return {
                loading: false,
                slideId: null
            }
        default:
            return state
    }
}